import { forwardRef, cloneElement } from 'react';
import type { BadgeProps, BadgeColor } from './Badge.types';

const badgeColors: Record<BadgeColor, { bg: string; text: string; hover: string; notificationBg: string; notificationText: string }> = {
  zinc: {
    bg: 'bg-zinc-100 dark:bg-zinc-950',
    text: 'text-zinc-700 dark:text-zinc-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-zinc-700 dark:bg-zinc-400',
    notificationText: 'text-zinc-100 dark:text-zinc-950'
  },
  red: {
    bg: 'bg-red-100 dark:bg-red-950',
    text: 'text-red-700 dark:text-red-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-red-700 dark:bg-red-400',
    notificationText: 'text-red-100 dark:text-red-950'
  },
  orange: {
    bg: 'bg-orange-100 dark:bg-orange-950',
    text: 'text-orange-700 dark:text-orange-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-orange-700 dark:bg-orange-400',
    notificationText: 'text-orange-100 dark:text-orange-950'
  },
  amber: {
    bg: 'bg-amber-100 dark:bg-amber-950',
    text: 'text-amber-700 dark:text-amber-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-amber-700 dark:bg-amber-400',
    notificationText: 'text-amber-100 dark:text-amber-950'
  },
  yellow: {
    bg: 'bg-yellow-100 dark:bg-yellow-950',
    text: 'text-yellow-700 dark:text-yellow-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-yellow-700 dark:bg-yellow-400',
    notificationText: 'text-yellow-100 dark:text-yellow-950'
  },
  lime: {
    bg: 'bg-lime-100 dark:bg-lime-950',
    text: 'text-lime-700 dark:text-lime-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-lime-700 dark:bg-lime-400',
    notificationText: 'text-lime-100 dark:text-lime-950'
  },
  green: {
    bg: 'bg-green-100 dark:bg-green-950',
    text: 'text-green-700 dark:text-green-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-green-700 dark:bg-green-400',
    notificationText: 'text-green-100 dark:text-green-950'
  },
  emerald: {
    bg: 'bg-emerald-100 dark:bg-emerald-950',
    text: 'text-emerald-700 dark:text-emerald-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-emerald-700 dark:bg-emerald-400',
    notificationText: 'text-emerald-100 dark:text-emerald-950'
  },
  teal: {
    bg: 'bg-teal-100 dark:bg-teal-950',
    text: 'text-teal-700 dark:text-teal-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-teal-700 dark:bg-teal-400',
    notificationText: 'text-teal-100 dark:text-teal-950'
  },
  cyan: {
    bg: 'bg-cyan-100 dark:bg-cyan-950',
    text: 'text-cyan-700 dark:text-cyan-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-cyan-700 dark:bg-cyan-400',
    notificationText: 'text-cyan-100 dark:text-cyan-950'
  },
  sky: {
    bg: 'bg-sky-100 dark:bg-sky-950',
    text: 'text-sky-700 dark:text-sky-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-sky-700 dark:bg-sky-400',
    notificationText: 'text-sky-100 dark:text-sky-950'
  },
  blue: {
    bg: 'bg-blue-100 dark:bg-blue-950',
    text: 'text-blue-700 dark:text-blue-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-blue-700 dark:bg-blue-400',
    notificationText: 'text-blue-100 dark:text-blue-950'
  },
  indigo: {
    bg: 'bg-indigo-100 dark:bg-indigo-950',
    text: 'text-indigo-700 dark:text-indigo-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-indigo-700 dark:bg-indigo-400',
    notificationText: 'text-indigo-100 dark:text-indigo-950'
  },
  violet: {
    bg: 'bg-violet-100 dark:bg-violet-950',
    text: 'text-violet-700 dark:text-violet-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-violet-700 dark:bg-violet-400',
    notificationText: 'text-violet-100 dark:text-violet-950'
  },
  purple: {
    bg: 'bg-purple-100 dark:bg-purple-950',
    text: 'text-purple-700 dark:text-purple-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-purple-700 dark:bg-purple-400',
    notificationText: 'text-purple-100 dark:text-purple-950'
  },
  fuchsia: {
    bg: 'bg-fuchsia-100 dark:bg-fuchsia-950',
    text: 'text-fuchsia-700 dark:text-fuchsia-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-fuchsia-700 dark:bg-fuchsia-400',
    notificationText: 'text-fuchsia-100 dark:text-fuchsia-950'
  },
  pink: {
    bg: 'bg-pink-100 dark:bg-pink-950',
    text: 'text-pink-700 dark:text-pink-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-pink-700 dark:bg-pink-400',
    notificationText: 'text-pink-100 dark:text-pink-950'
  },
  rose: {
    bg: 'bg-rose-100 dark:bg-rose-950',
    text: 'text-rose-700 dark:text-rose-400',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-rose-700 dark:bg-rose-400',
    notificationText: 'text-rose-100 dark:text-rose-950'
  },
  primary: {
    bg: 'bg-primary-100 dark:bg-primary-950',
    text: 'text-primary dark:text-primary-300',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-primary dark:bg-primary-200',
    notificationText: 'text-primary-50 dark:text-primary'
  },
  secondary: {
    bg: 'bg-secondary-50 dark:bg-secondary',
    text: 'text-secondary dark:text-secondary-300',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-secondary dark:bg-secondary-300',
    notificationText: 'text-secondary-50 dark:text-secondary'
  },
  tertiary: {
    bg: 'bg-tertiary-200 dark:bg-tertiary',
    text: 'text-tertiary dark:text-tertiary-300',
    hover: 'hover:brightness-98 dark:hover:brightness-95',
    notificationBg: 'bg-tertiary dark:bg-tertiary-300',
    notificationText: 'text-tertiary-200 dark:text-tertiary'
  },
};

/**
 * Badge del sistema de diseño Siesa
 *
 * Componente para mostrar etiquetas con múltiples variantes de color.
 * Los badges mantienen sus colores vibrantes en light y dark mode para
 * garantizar visibilidad y consistencia visual.
 *
 * Características implementadas:
 * - 21 variantes de color (zinc, red, orange, amber, yellow, lime, green, emerald, teal, cyan, sky, blue, indigo, violet, purple, fuchsia, pink, rose, primary, secondary, tertiary)
 * - Icono opcional a la izquierda (12x12px)
 * - Contador/notification badge opcional
 * - Estados hover con transiciones suaves
 * - Los colores se mantienen vibrantes en dark mode (según diseño Figma)
 * - Tipografía: Label Tiny (12px Bold)
 *
 * Mejores prácticas implementadas:
 * - Tokens de color de Tailwind estándar para badges
 * - Font-family explícita (Inter via font-sans)
 * - Transiciones suaves (duration-200)
 * - Estructura clara y mantenible
 *
 * @see docs/typography.md - Sistema tipográfico (Label Tiny)
 * @see https://www.figma.com/design/5XNqf2YTxvwemxwo1LMQ6j/Siesa-UI-Kit?node-id=4130-9382
 *
 * @example
 * ```tsx
 * // Badge simple
 * <Badge color="blue" label="Label" />
 *
 * // Badge con icono
 * <Badge color="green" label="Success" leftIcon={<CheckIcon />} />
 *
 * // Badge con contador
 * <Badge color="red" label="Errors" count={5} />
 *
 * // Badge completo
 * <Badge color="primary" label="Messages" leftIcon={<MailIcon />} count={12} />
 * ```
 */
export const Badge = forwardRef<HTMLDivElement, BadgeProps>(
  (
    {
      color = 'zinc',
      leftIcon,
      label,
      count,
      className = '',
      ...props
    },
    ref
  ) => {
    const colors = badgeColors[color] || badgeColors.zinc;

    // Renderizar icono con tamaño correcto (12x12)
    const renderIcon = (icon: React.ReactElement) => {
      const existingClassName = (icon.props as any).className || '';
      return (
        <span>
          {cloneElement(icon as React.ReactElement<any>, {
            className: `w-full h-full object-contain ${existingClassName}`.replace(/(w|h|size)-[wd-]+/g, '').trim(),
          })}
        </span>
      );
    };

    // ===== COMBINAR CLASES =====
    const isInteractive = 'onClick' in props;

    const finalClasses = [
      'inline-flex',
      'items-center',
      'justify-center',
      'gap-1',
      'px-1.5',
      'py-1',
      'rounded-md',
      colors.bg,
      isInteractive ? colors.hover : '',
      isInteractive ? 'cursor-pointer' : '',
      'transition-colors',
      'duration-200',
      className,
    ]
      .filter(Boolean)
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();

    return (
      <div
        ref={ref}
        className={finalClasses}
        {...props}
      >
        {/* Icono izquierdo */}
        {leftIcon && (
          <div className={`w-3 h-3 ${colors.text}`}>
            {renderIcon(leftIcon)}
          </div>
        )}

        {/* Label del badge */}
        <span className={`text-xs font-medium ${colors.text}`}>
          {label}
        </span>

        {/* Contador opcional */}
        {count !== undefined && (
          <span
            className={`text-xs font-medium px-1 rounded-sm ${colors.notificationBg} ${colors.notificationText}`}
            aria-label={`${count} notificaciones`}
          >
            {count > 99 ? '99+' : count}
          </span>
        )}
      </div>
    );
  }
);

Badge.displayName = 'Badge';
